module.exports = __webpack_public_path__ + "static/media/logo.e5c86a13.png";